// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardOfflineTrafficComponent } from './components/dashboard-offline-traffic/dashboard-offline-traffic.component';
import { StoreModule } from '@ngrx/store';
import { offlineTrafficReducer, STATE_NAME } from './store/offline-traffic.reducer';
import { EffectsModule } from '@ngrx/effects';
import { OfflineTrafficEffects } from './store/offline-traffic.effects';
import { SpyLineChartModule } from '@coa/app/shared/spy-line-chart/spy-line-chart.module';
import { IconTooltipModule } from '@coa/app/shared/icon-tooltip/icon-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { ChartDataSeriesModule } from '@coa/app/shared/chart-data-series/chart-data-series.module';
import { UniqueVisitsChartModule } from '@coa/app/shared/unique-visits-chart/unique-visits-chart.module';
import { FootTrafficModule } from '@coa/app/shared/foot-traffic/foot-traffic.module';
import { ScaleTicksPipeModule } from '@coa/app/shared/chart-js/scale-ticks-pipe/scale-ticks-pipe.module';
import { MultipleSeriesChartModule } from '@coa/app/shared/multiple-series-chart/multiple-series-chart.module';
import { DashboardOfflineTrafficContentComponent } from './components/dashboard-offline-traffic/dashboard-offline-traffic-content/dashboard-offline-traffic-content.component';
import { DashboardOfflineTrafficEmptyComponent } from './components/dashboard-offline-traffic/dashboard-offline-traffic-content/dashboard-offline-traffic-empty/dashboard-offline-traffic-empty.component';
import { ListModule } from '@coa/app/shared/list/list.module';


@NgModule({
  declarations: [
    DashboardOfflineTrafficComponent,
    DashboardOfflineTrafficContentComponent,
    DashboardOfflineTrafficEmptyComponent,
  ],
  imports: [
    CommonModule,
    StoreModule.forFeature(STATE_NAME, offlineTrafficReducer),
    EffectsModule.forFeature([OfflineTrafficEffects]),
    SpyLineChartModule,
    IconTooltipModule,
    TranslateModule,
    ChartDataSeriesModule,
    UniqueVisitsChartModule,
    FootTrafficModule,
    ScaleTicksPipeModule,
    MultipleSeriesChartModule,
    ListModule,
  ],
  exports: [
    DashboardOfflineTrafficComponent,
  ],
})
export class DashboardOfflineTrafficModule {
}
